import CustomizeNotifications from './CustomizeNotifications';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

export default ColumnsContent(CustomizeNotifications);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/CustomizeNotifications/index.js